import { adicionarToast, limparToasts, removerToast } from './store'
import type { ApiDeToast, OpcoesDeToast, OpcoesDeToastPorTipo } from './types'

function criarToast(titulo: string, opcoes?: OpcoesDeToast): string {
  return adicionarToast(titulo, opcoes)
}

export const toast: ApiDeToast = Object.assign(criarToast, {
  sucesso: (titulo: string, opcoes?: OpcoesDeToastPorTipo) =>
    adicionarToast(titulo, { ...opcoes, tipo: 'sucesso' as const }),

  erro: (titulo: string, opcoes?: OpcoesDeToastPorTipo) =>
    adicionarToast(titulo, { ...opcoes, tipo: 'erro' as const }),

  atencao: (titulo: string, opcoes?: OpcoesDeToastPorTipo) =>
    adicionarToast(titulo, { ...opcoes, tipo: 'atencao' as const }),

  info: (titulo: string, opcoes?: OpcoesDeToastPorTipo) =>
    adicionarToast(titulo, { ...opcoes, tipo: 'info' as const }),

  fechar: removerToast,
  limpar: limparToasts,
})

export function useToast(): ApiDeToast {
  return toast
}

export type {
  ApiDeToast,
  OpcoesDeToast,
  OpcoesDeToastPorTipo,
  TipoDeToast,
  Toast,
} from './types'
